<template>
    <div class="home-component">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <!-- 中间输入框 -->
        <input
          v-model="searchQuery"
          type="text"
          class="search-input"
          placeholder="请输入搜索内容"
        />
  
        <!-- 右侧搜索图标 -->
        <button class="search-button" @click="handleSearch">
          <img src="@/assets/search.png" alt="搜索" class="search-icon" />
        </button>
      </div>
  
      <!-- 排序栏 -->
      <div class="sort-bar">
        <!-- 区域 -->
        <div class="sort-item">
          <select v-model="selectedRegion" class="sort-dropdown">
            <option value="">区域</option>
            <option v-for="(region, index) in regions" :key="index" :value="region">
              {{ region }}
            </option>
          </select>
        </div>
  
        <!-- 一级分类 -->
        <div class="sort-item">
          <select v-model="selectedCategory" class="sort-dropdown" @change="loadSubCategories">
            <option value="">类型</option>
            <option v-for="(category, index) in categories" :key="index" :value="category">
              {{ category }}
            </option>
          </select>
        </div>
  
        <!-- 二级分类（动态显示） -->
        <div class="sort-item" v-if="showSubCategory">
          <select v-model="selectedSubCategory" class="sort-dropdown">
            <option value="">子类型</option>
            <option v-for="(subCategory, index) in subCategories" :key="index" :value="subCategory">
              {{ subCategory }}
            </option>
          </select>
        </div>
  
        <!-- 价格 -->
        <div class="sort-item">
          <select v-model="selectedPrice" class="sort-dropdown">
            <option value="">价格</option>
            <option v-for="(price, index) in priceOptions" :key="index" :value="price">
              {{ price }}
            </option>
          </select>
        </div>
  
        <!-- 更多 -->
        <div class="sort-item">
          <select v-model="selectedMore" class="sort-dropdown">
            <option value="">更多</option>
            <option v-for="(more, index) in moreOptions" :key="index" :value="more">
              {{ more }}
            </option>
          </select>
        </div>
  
        <!-- 排序 -->
        <div class="sort-item">
          <select v-model="selectedSort" class="sort-dropdown">
            <option value="">排序</option>
            <option v-for="(sort, index) in sortOptions" :key="index" :value="sort">
              {{ sort }}
            </option>
          </select>
        </div>
      </div>
  
      <!-- 搜索结果列表 -->
      <!-- 搜索结果列表 -->
    <div class="search-results">
      <div
        v-for="(item, index) in searchResults"
        :key="index"
        class="result-item"
        @click="goToDetail(item.id)" 
      >
        <!-- 左侧内容 -->
        <div class="result-left">
          <div class="result-title">{{ item.title }}</div>
          <div class="result-tags">
            <span v-for="(tag, tagIndex) in item.tags" :key="tagIndex" class="tag">{{ tag }}</span>
          </div>
          <div class="result-price">{{ item.price }}</div>
        </div>

        <!-- 右侧图片 -->
        <div class="result-right">
          <img :src="item.image" alt="图片" class="result-image" />
        </div>
      </div>
    </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  import { useRouter } from 'vue-router'; 
  
  type CategoryKey = '农用地' | '建设用地' | '未利用地'; // 定义一级分类的键类型
  
  export default defineComponent({
    name: 'HomeComponent',
    setup() {
    const router = useRouter(); // 获取路由实例

    // 跳转到详情页面
    const goToDetail = (id: string) => {
      router.push({ name: 'Detail', params: { id } }); // 使用路由跳转
    };

    return {
      goToDetail,
    };
  },
    data() {
      return {
        searchQuery: '', // 搜索内容
        selectedRegion: '', // 选中的区域
        regions: ['北京', '上海', '广州', '深圳', '杭州', '成都', '武汉', '南京'], // 区域列表
  
        // 一级分类
        selectedCategory: '', // 选中的一级分类
        categories: ['农用地', '建设用地', '未利用地', '其他用地', '住宅用地', '商业用房', '工业用房', '其他用房'], // 一级分类列表
  
        // 二级分类
        selectedSubCategory: '', // 选中的二级分类
        subCategories: [] as string[], // 二级分类列表
        showSubCategory: false, // 是否显示二级分类
  
        // 排序栏数据
        selectedPrice: '', // 价格
        selectedMore: '', // 更多
        moreOptions: [] as string[], // 动态生成的更多选项
        selectedSort: '', // 排序
        sortOptions: ['默认排序', '价格从低到高', '价格从高到低', '面积从大到小', '面积从小到大', '发布时间从新到旧', '发布时间从旧到新'], // 排序选项
  
        // 价格选项
        priceOptions: [] as string[], // 动态生成的价格选项
  
        // 分类数据（仅包含需要二级分类的类型）
        categoryOptions: {
          '农用地': [
            '不限',
            '耕地（水田、水浇地、旱地）',
            '园地（果园、茶园、橡胶园、其他园地）',
            '林地（乔木林地、竹林地、红树林地、森林沼泽、灌木林地、灌丛沼泽、其他林地）',
            '草地（天然牧草地、沼泽草地、人工牧草地）',
            '交通运输用地（农村道路）',
            '水域及水利设施用地（水库水面、坑塘水面、沟渠）',
            '其它土地（设施农用地、田坎）',
          ],
          '建设用地': [
            '不限',
            '商服用地（零售商业用地、批发市场用地、餐饮用地、旅馆用地、商务金融用地、娱乐用地、其他商服用地）',
            '工矿仓储用地（工业用地、采矿用地、盐田、仓储用地）',
            '住宅用地（城镇住宅用地、农村宅基地）',
            '公共管理与公共服务用地（机关团体用地、新闻出版用地、教育用地、科研用地、医疗卫生用地、社会福利用地、文化设施用地、体育用地、公用设施用地、公园与绿地）',
            '特殊用地（军事设施用地、使领馆用地、监教场所用地、宗教用地、殡葬用地、风景名胜设施用地）',
            '交通运输用地（铁路用地、轨道交通用地、公路用地、城镇村道路用地、交通服务场站用地、机场用地、港口码头用地、管道运输用地）',
            '水域及水利设施用地（水工建筑用地）',
            '其它土地（空闲地）',
          ],
          '未利用地': [
            '不限',
            '水域及水利设施用地（河流水面、湖泊水面、沿海滩涂、内陆滩涂、沼泽地、冰川及永久积雪）',
            '草地（其他草地）',
            '其它土地（盐碱地、沙地、裸土地、裸岩石砾地）',
          ],
        } as Record<CategoryKey, string[]>, // 明确 categoryOptions 的类型
  
        // 搜索结果列表数据
        searchResults: [
          {
            id: '1',
            title: '溪畔民宿，流水潺潺',
            tags: ['民宿', '荷花'],
            price: '¥ 50,000 / 年',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1098.jpg',
          },
          {
            id: '2',
            title: '古镇民宿，感受历史韵味',
            tags: ['民宿', '古镇'],
            price: '¥ 1,20,000 / 年',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1099.jpg',
          },
          {
            id: '3',
            title: '千年茶乡用地，传承茶文化',
            tags: ['茶叶', '交通便利'],
            price: '¥ 800,000 / 亩',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1100.jpg',
          },
          {
            id: '4',
            title: '生态林业用地，天然氧吧',
            tags: ['林地'],
            price: '¥ 1800,000 / 公顷',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1101.jpg',
          },
          {
            id: '5',
            title: '乡村宅基地，田园生活新选择',
            tags: ['宅基地', '交通便利'],
            price: '面议',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1102.jpg',
          },
          {
            id: '6',
            title: '山林养鸡地，自由奔跑',
            tags: ['养鸡'],
            price: '¥ 280,00 / 亩 / 年',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1103.jpg',
          },
          {
            id: '7',
            title: '田园风情民宿用地，拥抱自然',
            tags: ['民宿', '田园'],
            price: '¥ 800,000',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1104.jpg',
          },
          {
            id: '8',
            title: '花海民宿用地，四季如画',
            tags: ['民宿', '交通便利'],
            price: '面议',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1105.jpg',
          },
          {
            id: '9',
            title: '温泉民宿用地，冬日暖意',
            tags: ['民宿', '温泉'],
            price: '¥ 280,000 / 年',
            image: 'https://rpa-apk.oss-cn-wulanchabu.aliyuncs.com/dy/WechatIMG1106.jpg',
          },
        ], // 搜索结果列表
      };
    },
    watch: {
      // 监听一级分类变化，动态加载二级分类
      selectedCategory(newCategory: string) {
        this.selectedSubCategory = ''; // 清空二级分类
        if (this.isCategoryWithSub(newCategory)) {
          this.subCategories = this.categoryOptions[newCategory]; // 加载二级分类
          this.showSubCategory = true; // 显示二级分类
        } else {
          this.subCategories = []; // 清空二级分类
          this.showSubCategory = false; // 隐藏二级分类
        }
  
        // 根据一级分类更新价格和更多选项
        this.generatePriceOptions(newCategory);
        this.generateMoreOptions(newCategory);
      },
  
      // 监听二级分类变化，动态生成价格和更多选项
      selectedSubCategory(newSubCategory: string) {
        // 如果二级分类有值，则根据二级分类更新价格和更多选项
        if (newSubCategory) {
          this.generatePriceOptions(newSubCategory);
          this.generateMoreOptions(newSubCategory);
        } else {
          // 如果二级分类为空，则根据一级分类更新价格和更多选项
          this.generatePriceOptions(this.selectedCategory);
          this.generateMoreOptions(this.selectedCategory);
        }
      },
    },
    methods: {
      // 判断一级分类是否有二级分类
      isCategoryWithSub(category: string): category is CategoryKey {
        return category in this.categoryOptions;
      },
  
      // 处理搜索
      handleSearch() {
        if (this.searchQuery.trim()) {
          alert(`搜索内容：${this.searchQuery}，区域：${this.selectedRegion}，类型：${this.selectedCategory}${this.selectedSubCategory ? ' - ' + this.selectedSubCategory : ''}`);
        } else {
          alert('请输入搜索内容');
        }
      },
  
      // 根据类型生成价格选项
      generatePriceOptions(type: string) {
        if (type.includes('用地')) {
          // 用地价格选项（租、售，总价和单价，以宗和亩为单位）
          this.priceOptions = [
            '租-总价（宗）：0-10万', '租-总价（宗）：10-50万', '租-总价（宗）：50万以上',
            '租-单价（亩）：0-1万', '租-单价（亩）：1-5万', '租-单价（亩）：5万以上',
            '售-总价（宗）：0-100万', '售-总价（宗）：100-500万', '售-总价（宗）：500万以上',
            '售-单价（亩）：0-10万', '售-单价（亩）：10-50万', '售-单价（亩）：50万以上',
          ];
        } else if (type.includes('用房')) {
          // 用房价格选项（租、售，总价和单价，以套和平方为单位）
          this.priceOptions = [
            '租-总价（套）：0-1万', '租-总价（套）：1-5万', '租-总价（套）：5万以上',
            '租-单价（平方）：0-100元', '租-单价（平方）：100-500元', '租-单价（平方）：500元以上',
            '售-总价（套）：0-100万', '售-总价（套）：100-500万', '售-总价（套）：500万以上',
            '售-单价（平方）：0-1万', '售-单价（平方）：1-5万', '售-单价（平方）：5万以上',
          ];
        } else {
          // 默认价格选项
          this.priceOptions = [];
        }
      },
  
      // 根据类型生成更多选项
      generateMoreOptions(type: string) {
        if (type.includes('用地')) {
          // 用地更多选项
          this.moreOptions = ['方式', '面积', '年限'];
        } else if (type.includes('用房')) {
          // 用房更多选项
          this.moreOptions = ['方式', '建筑面积', '年限', '楼层', '朝向', '装修', '居室', '卫生间', '房龄', '特点'];
        } else {
          // 默认更多选项
          this.moreOptions = [];
        }
      },
    },
    mounted() {
      // 初始化价格和更多选项
      this.generatePriceOptions(this.selectedCategory);
      this.generateMoreOptions(this.selectedCategory);
    },
  });
  </script>
  
  <style scoped>
  .home-component {
    padding: 20px;
  }
  
  /* 搜索栏样式 */
  .search-bar {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 25px; /* 圆角矩形 */
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 阴影效果 */
    max-width: 600px;
    margin: 0 auto 20px;
  }
  
  /* 输入框 */
  .search-input {
    flex: 1;
    border: none;
    outline: none;
    padding: 8px;
    font-size: 14px;
  }
  
  /* 搜索按钮 */
  .search-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
  }
  
  .search-icon {
    width: 20px;
    height: 20px;
  }
  
  /* 排序栏样式 */
  .sort-bar {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 10px; /* 圆角矩形 */
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 阴影效果 */
    max-width: 600px;
    margin: 0 auto;
  }
  
  .sort-item {
    flex: 1;
    margin: 0 5px;
  }
  
  .sort-dropdown {
    width: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 14px;
    cursor: pointer;
  }
  
  /* 搜索结果列表样式 */
  .search-results {
    max-width: 600px;
    margin: 20px auto;
  }
  
  .result-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .result-left {
    flex: 1;
    margin-right: 20px;
  }
  
  .result-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  
  .result-tags {
    margin-bottom: 8px;
  }
  
  .tag {
    display: inline-block;
    background-color: #f0f0f0;
    border-radius: 4px;
    padding: 4px 8px;
    margin-right: 8px;
    font-size: 12px;
    color: #666;
  }
  
  .result-price {
    font-size: 14px;
    color: #e67e22;
    font-weight: bold;
  }
  
  .result-right {
    width: 100px;
    height: 100px;
  }
  
  .result-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
  </style>